import type { IArticle, IMagazineImpactMetrics, IResearchTopic } from "~/types";
import { ArticleSortOptionEnum } from "~/enums/ArticleSortOptionEnum";
import { SearchDataModel } from "~/types/models/SearchData.model";
import {
  findEditorial,
  getCoverImageUrl,
  getCoverType,
  isEditorial,
  mapImpactV5ToMagazineMetrics
} from "~/helpers/magazineHelpers";
import { MAGAZINE_PAGE_SIZE } from "~/helpers/magazineLayout";

export const useMagazineService = () => {
  const getMagazineResearchTopic = (): IResearchTopic => {
    const store = useMain();
    if (!store.currentResearchTopic?.id) {
      throw new Error(
        "Research topic is not loaded. Fetch it in middleware on the server first."
      );
    }
    return store.currentResearchTopic;
  };

  const getMagazineArticles = async (
    rtId: number,
    skip: number = 0,
    limit: number = MAGAZINE_PAGE_SIZE
  ): Promise<IArticle[]> => {
    const params = new SearchDataModel(
      skip,
      limit,
      ArticleSortOptionEnum.DATE,
      true,
      true
    );

    if (import.meta.server) {
      const { getArticles } = useMongoDbService();
      return getArticles(rtId, params);
    }

    const { getArticlesByResearchTopicId } = useRtApiService();
    return getArticlesByResearchTopicId(rtId, params);
  };

  const getMagazineImpactMetrics = (
    rt: IResearchTopic
  ): IMagazineImpactMetrics => mapImpactV5ToMagazineMetrics(rt);

  return {
    getMagazineResearchTopic,
    getMagazineArticles,
    getMagazineImpactMetrics,
    getCoverType,
    getCoverImageUrl,
    isEditorial,
    findEditorial
  };
};
